export default __webpack_public_path__ + "static/media/videoclip.c0c6215a.png";